import React from 'react';
import glamorous, { Img, Div, Span } from 'glamorous';
import {dimensions, box, spacing, type, textColor, borders, leading, color } from '../../../style';
import DateRange from './DateRange';
import { whoPays } from "../../../mt";

export default (props) => {


  const Row = glamorous.div(
    {
      marginBottom: 22,

      [dimensions.SCREEN_MIN_LG]: {
        display: 'flex',
      }
    }
  )

  const Label = glamorous.div(
    {
      flex: '0 0 25%',
      color: '#9E9E9E',
      fontSize: 16,
      marginBottom: 8,

      [dimensions.SCREEN_MAX_MD]: {

      }
    }
  )

  const LockupContainer = glamorous.div(
    {
      // display: 'flex'
    }
  )

  const Content = glamorous.div(
    {
      fontSize: 16,
      lineHeight: 1.5,
      color: '#575757'
    }
  )

  const Tag = glamorous.span(
    {
      fontSize: 14,
      display: 'inline-block',
      verticalAlign: 'middle',
      color: color.BRAND_1,
      padding: '6px 19px',
      borderRadius: 18,
      border: '1px solid #C2C2C2',
      marginRight: 6,
      marginBottom: 8
    }
  )

  return function UserLockup(props) {
    const {
      trip
    } = props;

    return (
      <LockupContainer>
        <Row>
          <Label>When</Label>
          <Content>
            <DateRange
              leave={trip.leaving_dt.date}
              return={trip.returning_dt.date}
              isFlexible={trip.flexible_dates}
            />
          </Content>
        </Row>
        <Row>
          <Label>Who's paying</Label>
          <Content>
            <b>{ whoPays(trip.who_pays) }</b>
          </Content>
        </Row>
        <Row>
          <Label>Description</Label>
          <Content>
            { trip.description }
          </Content>
        </Row>
        { trip.tag.data && trip.tag.data.length > 0 ?
          <Row>
            <Label>Tags</Label>
            <Content>
              {trip.tag && trip.tag.data.map(item => {
                return <Tag key={item.id}> { item.tag } </Tag>
              })}
            </Content>
          </Row> :
          null
        }
      </LockupContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripInfo.jsx